// extracted by mini-css-extract-plugin
export default {"productGallery":"GJ-z","inQuickShop":"HJ-z"};